import { DocViewer } from "../common/DocViewer";
import { Button } from "@repo/ui/components/Base/Button";
import { AppUrlPath } from "@/lib/AppUrlPath";
import { useNavigate } from "react-router-dom";
import { useUserStore } from "@/stores/userStore";
import { useGetDocument } from "@/hooks/queryHooks/documentHooks";
import { documentRepo } from "@/repositories/documentRepo";

export const DocumentDisplay = ({
  tenantId,
  documentId,
}: {
  tenantId: string;
  documentId: string;
}) => {
  const navigate = useNavigate();

  const { data: doc } = useGetDocument(tenantId, documentId);
  const { activeTeam, hasMinRole } = useUserStore(
    ({ activeTeam, hasMinRole }) => ({ activeTeam, hasMinRole })
  );

  const handleView = () => {
    const appUrlPath = new AppUrlPath(tenantId);
    navigate(appUrlPath.getDocumentPath(documentId));
  };

  const showDocument =
    !doc?.confidential ||
    (activeTeam !== "org" &&
      activeTeam?.id &&
      doc?.teamId &&
      activeTeam.id === doc.teamId &&
      hasMinRole("edit"));

  const attachment = doc ? documentRepo.getLinkedAttachment(doc) : null;

  return (
    <div>
      <div className="flex flex-row justify-between gap-x-2">
        <h2 className="text-xl p-2">{doc?.name ?? "..."}</h2>
        <Button type="button" onClick={() => handleView()}>
          View
        </Button>
      </div>
      {showDocument ? (
        <div className="flex flex-col gap-2 overflow-hidden">
          <DocViewer documentUri={attachment?.url ?? ""} />
        </div>
      ) : (
        <p className="text-center">Document is confidential</p>
      )}
    </div>
  );
};
